import { render } from "./LeaveSummaries.vue?vue&type=template&id=39b572b1"
import script from "./LeaveSummaries.vue?vue&type=script&lang=js"
export * from "./LeaveSummaries.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__